import type React from "react";
import { Text, View } from "react-native";
import Toast, {
  BaseToast,
  type ToastConfig,
  type ToastShowParams,
} from "react-native-toast-message";

export const toastConfig: ToastConfig = {
  success: (props) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: "#2C7A7B" }}
      text1Style={{ fontSize: 14, fontWeight: "600" }}
      text2Style={{ fontSize: 12, color: "#1A202C" }}
    />
  ),
  error: (props) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: "#E53E3E" }}
      text1Style={{ fontSize: 14, fontWeight: "600" }}
      text2Style={{ fontSize: 12, color: "#1A202C" }}
    />
  ),
  info: (props) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: "#FCF9F5" }}
      text1Style={{ fontSize: 14, fontWeight: "600" }}
      text2Style={{ fontSize: 12, color: "#1A202C" }}
    />
  ),
  custom: ({ text1, props }) => (
    <View
      className="mx-4 rounded-xl bg-teachLoop-creamBase p-4 shadow-lg"
      style={{ elevation: 4 }}
    >
      {!!text1 && (
        <Text className="mb-2 text-sm font-geologica-medium text-teachLoop-textPrimary">
          {text1}
        </Text>
      )}
      {props?.content}
    </View>
  ),
};

type CustomToastParams = Omit<ToastShowParams, "type" | "props"> & {
  props: { content: React.ReactNode };
};

export function showCustomToast(params: CustomToastParams) {
  Toast.show({ ...params, type: "custom" });
}
